const isNullOrBlank = (v) => v == null || String(v).trim() === '';

// console.log(isNullOrBlank(null));
// console.log(isNullOrBlank(undefined));
// console.log(isNullOrBlank(''));
// console.log(isNullOrBlank(' '));
// console.log(isNullOrBlank('0'));
// console.log(isNullOrBlank(0));
// console.log(isNullOrBlank(false));
// console.log(isNullOrBlank(true));
// console.log(isNullOrBlank('aa'));

const isUserPermitted = (roles = [], userRoles = []) => {
	return roles?.some((role) => userRoles?.includes(role));
};

export { isNullOrBlank, isUserPermitted };
